<template>
  <div id="show-hospital">
    <b-row>
      <b-col md="6">
        <card class="stacked-form">
          <l-progress v-if="isLoading" :value="100" :height="20" class="mb-2" type="info" :animated="true" :striped="true"></l-progress>
          <form v-on:submit.prevent="doSubmit">
            <fg-input :required="true" for-input="oldPassword" type="password" name="oldPassword" id="oldPassword" label="Current Password" placeholder="Enter Current Password" v-validate="modelValidations.oldPassword" :error="errors.first('oldPassword')" v-model="model.oldPassword" data-vv-as="current password"/>
            <div class="form-group" v-bind:class="{ 'has-error': errors.first('password') }">
              <label>Password *</label>
              <input
                class="form-control"
                ref="confirmed:newPassword"
                type="password" name="newPassword" id="newPassword" label="newPassword" placeholder="Enter New Password" v-validate="modelValidations.newPassword" :error="errors.first('newPassword')" v-model="model.newPassword" data-vv-as="new password"
                aria-describedby="addon-right addon-left">
              <slot name="infoBlock"></slot>
              <slot name="helpBlock">
                <div class="text-danger invalid-feedback" style="display: block;" v-if="errors.first('newPassword')">
                  {{ errors.first('newPassword') }}
                </div>
              </slot>
            </div>
            <fg-input :required="true" for-input="passwordConfirmation" type="password" name="passwordConfirmation" id="passwordConfirmation" label="Confirm Password" placeholder="Enter Confirm Password" v-validate="modelValidations.passwordConfirmation" :error="errors.first('passwordConfirmation')" v-model="model.passwordConfirmation" data-vv-as="confirm password"/>
            <div class="mt-5"></div>
            <save-data-button :disabled="saveButtonData.isLoading" :is-create="true" :state="saveButtonData.isLoading && saveButtonData.state === 1 ? 2 : saveButtonData.state" :is-loading="saveButtonData.isLoading"/>
            <back-button/>
          </form>
        </card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {Switch} from 'element-ui'
  import {Progress as LProgress} from 'src/components/index'
  import Back from '@/components/Buttons/Back'
  import SaveData from '@/components/Buttons/SaveData'

  export default {
    components: {
      SaveDataButton: SaveData,
      LProgress,
      BackButton: Back,
      LSwitch: Switch
    },
    data () {
      return {
        isLoading: false,
        saveButtonData: {
          isLoading: false,
          state: 1
        },
        dataAccount: this.$store.getters['account/accountData'],
        apiUrlChangePassword: window.AppConfig.apiUrl + 'change-password',
        model: {
          oldPassword: '',
          newPassword: '',
          passwordConfirmation: ''
        },
        modelValidations: {
          oldPassword: {
            required: true
          },
          newPassword: {
            required: true
          },
          passwordConfirmation: {
            required: true
          }
        }
      }
    },
    methods: {
      doSubmit () {
        this.$validator.validate().then(res => {
          if (res) {
            this.saveButtonData.isLoading = true
            this.$http.post(this.apiUrlChangePassword, this.model).then(response => {
              this.saveButtonData.isLoading = false
              this.$store.dispatch('notification/success', 'Password has been change.')
              window.location.href = document.URL.replace('/change-password', '')
            }).catch(error => {
              this.saveButtonData.isLoading = false
              this.$store.dispatch('notification/error', error)
            })
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Profile/ChangePassword.vue